<template>
  <div class="alarm_wrap">
    <a-spin :spinning="loading">
      <div class="search-container">
        <div class="search-item">
          <a-range-picker
            size="large"
            v-model:value="dateList"
            :placeholder="['开始时间', '结束时间']"
            allowClear
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD HH:mm:ss"
          />
        </div>
        <div class="search-item">
          <a-select
            v-model:value="listQuery.warningType"
            placeholder="预警类型"
            style="width: 224px"
            size="large"
            :options="warningTypeMap"
            allowClear
          ></a-select>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" type="primary" @click="handleSearch">
            搜索
          </a-button>
        </div>
      </div>
      <div class="data_wrap" :style="{ maxHeight: `calc(100vh - ${202}px )` }">
        <ul v-if="tableData.length">
          <li v-for="(item, index) in tableData" :key="index">
            <div v-if="item.warningType === 2">
              <span class="time">{{ item.warningTime }}</span>
              【{{
                item.warningHeader
              }}】因有待处理工单达到10分钟时效，超过3次未处理，导致工单回滚工单池，系统已强制下线处理将登录状态调整为休息。
            </div>
            <div v-else>
              <span class="time">{{ item.warningTime }}</span>
              【{{ item.warningHeader }}】【
              <span class="orderId" @click="getWorkOrder(item.warningBusinessId)">
                {{ item.warningBusinessId }}
              </span>
              】已超2小时未分配。
            </div>
          </li>
        </ul>
        <div v-else class="empty z-flex-c">
          <div>
            <img src="~@/assets/img/empty.png" alt="" />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div class="pagination">
        <a-pagination
          size="small"
          :total="pagination.total"
          show-size-changer
          show-quick-jumper
          :show-total="total => `共${pagination.total} 条`"
          @change="onChangePage"
          @showSizeChange="onChangePage"
        />
      </div>
    </a-spin>
  </div>
</template>
<script setup>
import { reactive, ref, onMounted, computed } from 'vue'
import { warningTypeMap } from './config.js'
import { useRouter } from 'vue-router'
import { getWarningTipList } from '@/api/AlarmReminder'
import { formatDateForFilter } from '@/utils'
import { useStore } from 'vuex'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { cloneDeep } from 'lodash-es'
const store = useStore()
const router = useRouter()
const pagination = reactive({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0
})
const tableData = ref([])
const loading = ref(false)
const dateList = ref([])
const listQuery = reactive({
  warningType: null
})
const defaultQuery = {
  warningType: null,
  dateList: []
}
const { initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.ALARM_REMINDER_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultQuery,
  normalize: params => ({
    ...cloneDeep(defaultQuery),
    ...cloneDeep(params),
    dateList: Array.isArray(params?.dateList) ? params.dateList : []
  })
})

function searchList() {
  loading.value = true
  const { current, pageSize } = pagination
  const [startTime, endTime] = formatDateForFilter(dateList.value)
  const params = {
    ...listQuery,
    pageNo: current,
    pageSize,
    startTime,
    endTime
  }
  getWarningTipList(params)
    .then(res => {
      const { list, totalCount } = res
      tableData.value = list
      pagination.total = totalCount
    })
    .catch(() => {
      tableData.value = []
      pagination.total = 0
    })
    .finally(() => {
      store.dispatch('alarm/getUnProcessAlarmReadFlag')
      loading.value = false
    })
}
const handleSearch = () => {
  pagination.current = 1
  pagination.pageSize = 10
  updateCache({
    warningType: listQuery.warningType,
    dateList: dateList.value
  })
  searchList()
}
const onChangePage = (current, size) => {
  pagination.current = current
  pagination.pageSize = size
  updateCache({
    warningType: listQuery.warningType,
    dateList: dateList.value
  })
  searchList()
}
//查看关联工单
const getWorkOrder = id => {
  router.push({
    path: '/todo',
    query: {
      workOrderIdList: id
    }
  })
}
// function disabledDate(current) {
//   return current && current < moment().subtract(1, 'year').endOf('day')
// }
onMounted(() => {
  const cacheQuery = initFromCache()
  listQuery.warningType = cacheQuery.warningType
  dateList.value = cacheQuery.dateList || []
  searchList()
})
</script>
<style scoped lang="scss">
.alarm_wrap {
  height: 100%;
  .search-container {
    padding: 10px 20px 0;
    background-color: #ffffff;
    .search-item {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 12px;
      .search-input {
        width: 224px;
      }
    }
  }
  .data_wrap {
    background-color: #ffffff;
    margin: 24px;
    border-radius: 4px;
    overflow: auto;
    ul {
      list-style: none;
      padding: initial;
      & > li {
        padding: 16px 24px;
        &:not(:first-child) {
          border-top: 1px solid #0000000f;
        }
        .time {
          margin-right: 25px;
        }
        .orderId {
          color: #1890ff;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
        }
      }
    }
    .empty {
      height: 300px;
      justify-content: center;
      div {
        text-align: center;
      }
    }
  }
  .pagination {
    margin: 24px;
  }
}
</style>
